import { Input } from '@apia/theme';
import React from 'react';
import { TApiaFilter, TApiaFilterValue } from '@apia/util';
import { ApiaFilter } from '@apia/components';
import { useResponsiveTableContext } from './ResponsiveTableContext';
import { domPropsSelector } from './ResponsiveTable';
import { RangeFilter } from './filters/RangeFilter';
import { useDomProps } from './store/selection/useDomProps';
import { TResponsiveTableContextProps } from './types';

interface IFilterCell {
  columnIndex: number;
  filter?: TApiaFilter;
  Renderer?: ReturnType<
    NonNullable<TResponsiveTableContextProps['FiltersRenderer']>
  >;
}

export const FilterCell = ({ columnIndex, filter, Renderer }: IFilterCell) => {
  const { name, onFilterBlur, onFilterChange, onFilterPressEnter } =
    useResponsiveTableContext();
  const domProps = useDomProps(
    'filterTd',
    {
      columnIndex,
    },
    domPropsSelector(name),
  );

  const handleOnBlur = React.useCallback(
    (currentValue: TApiaFilterValue) => {
      if (filter && onFilterBlur) onFilterBlur({ ...filter, currentValue });
    },
    [filter, onFilterBlur],
  );

  const handleOnChange = React.useCallback(
    (currentValue: TApiaFilterValue) => {
      if (filter && onFilterChange)
        return onFilterChange({ ...filter, currentValue });
      return true;
    },
    [filter, onFilterChange],
  );

  const handleOnPressEnter = React.useCallback(
    (currentValue: TApiaFilterValue) => {
      if (filter && onFilterPressEnter)
        onFilterPressEnter({ ...filter, currentValue });
    },
    [filter, onFilterPressEnter],
  );

  function findFilter() {
    if (filter?.isRange) {
      return <RangeFilter filter={filter} />;
    }
    if (filter && !(filter.asAdditional || !filter.column || filter.isRange)) {
      return (
        <ApiaFilter
          onBlur={handleOnBlur}
          onChange={handleOnChange}
          onPressEnter={handleOnPressEnter}
          filter={filter}
        />
      );
    }

    let label: string;
    if (filter && (filter.asAdditional || !filter.column || filter.isRange)) {
      label = window.LBL_ADDITIONAL_FILTER;
    } else {
      label = window.LBL_NO_COLUMN_FILTER;
    }

    return <Input aria-label={label} disabled />;
  }
  return (
    <td {...domProps}>
      {Renderer ? <Renderer filter={filter!} /> : findFilter()}
    </td>
  );
};
